import store from 'Redux/store';
import { VALID_THEMES } from 'Config/site-themes';

export const SWITCH_SITE_THEME = 'frontend/site-theme/SWITCH_SITE_THEME';

export function switchSiteTheme(value) {
  if (VALID_THEMES.includes(value)) {
    localStorage.setItem('siteTheme', value);
    store.dispatch({ type: SWITCH_SITE_THEME, payload: value });
  }
}
